import { fetch as fetchMap, setCurrentArea, setCurrentSetting, } from 'actions/map';
import { fetchUser, loginSuccess } from 'actions/user';

import { fetchActions } from 'actions/actions';
import { fetch as fetchCards } from 'actions/cards';
import { fetchMyself, fetchOutfit } from 'actions/myself';
import { fetchExchange } from 'actions/exchange';
import { fetch as fetchFate } from 'actions/fate';
import { getSupportingData } from 'actions/infoBar';
import { fetch as fetchMessages } from 'actions/messages';
import { fetch as fetchNews } from 'actions/news';
import { fetchPlans } from 'actions/plans';
import { fetchAvailable as fetchAvailableStorylets } from 'actions/storylet';
import Config from 'configuration';

import destructureJwt from 'utils/destructureJwt';
// import extractImages from './extractImages';
// import preloadImages from './preloadImages';
import preloadImages from 'actions/app/preloadImages';
import extractImages from 'actions/app/extractImages';

const FLAG_PREFETCH_NON_MAP_IMAGES = false;

/**
 * Fetch the data we need to get the character's current state from a cold start.
 * This should only really be called when the user logs in, or refreshes (or opens a tab)
 * while holding a valid authentication token.
 */

export interface IBootstrapOptions {
  fetchSpritesNow?: boolean,
  onSpriteLoadProgress?: (_?: any) => any,
}

export default function performInitialRequests(options = {}) {
  return async (dispatch: Function) => {
    // Have we got a JWT with a character ID?
    const { characterId } = destructureJwt();
    // If not, then just return.
    if (!characterId) {
      return;
    }

    // Fetch myself qualities and optionally prefetch quality images
    const myselfData = await dispatch(fetchMyself());
    // No need to await images
    if (myselfData && FLAG_PREFETCH_NON_MAP_IMAGES) {
      const images = extractImages();
      preloadImages(images.map(image => `${Config.imageUrl}icons_small/${image}.png`));
    }

    if (myselfData?.character?.setting !== undefined) {
      dispatch(setCurrentSetting(myselfData.character.setting));
    }

    // Fetch outfit
    dispatch(fetchOutfit());

    // Fetch storylet data too --- we need this even if we're loading the possessions
    // tab (or whatever), because we need to render usable items as blocked if the user
    // is in a storylet
    dispatch(fetchAvailableStorylets());

    // Go fetch opp cards too --- remove this responsibility
    // from the mount methods of card components
    dispatch(fetchCards());

    // Fetch messages
    dispatch(fetchMessages());

    // Fetch plans — we need them in order to check whether a player can add a plan
    dispatch(fetchPlans());

    // Get the user data, which we need for a few things
    const data = await dispatch(fetchUser());

    // Now that we have user data, fetch the other stuff we need to load up

    // If we have an area key-value pair, set the current area now
    // (this will change in a future API update)
    if (data.area) {
      dispatch(setCurrentArea(data.area));
    }

    // If we have a Setting k-v pair, set it now
    if (data.setting) {
      dispatch(setCurrentSetting(data.setting));
    }

    dispatch(loginSuccess(data));

    // We may not get any map data from the server --- e.g. when the player is registering a
    // new character --- so we need to account for it
    // Fetch the map. This will also load map sprites, so can take a while
    const mapData = await dispatch(fetchMap(options));
    if (mapData?.currentArea) {
      dispatch(setCurrentArea(mapData.currentArea));
    }

    // Fetch bazaar data and optionally fetch images
    const exchangeData: any = await fetchExchange();
    if (exchangeData?.exchange?.shops && FLAG_PREFETCH_NON_MAP_IMAGES) {
      const { exchange: { shops } } = exchangeData;
      preloadImages(shops.map((s: any) => s.image).map((image: any) => `${Config.imageUrl}icons_small/${image}.png`));
    }

    // Fetch action bank stuff
    dispatch(fetchActions());

    // Fetch news and infobar stuff
    dispatch(fetchNews());
    dispatch(getSupportingData());

    // Fetch fate data
    dispatch(fetchFate());
  };
}